<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="30px">

    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ title }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="siteForm">
                <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center center">
                    <mat-form-field>
                        <mat-label>{{'SITE-DETAILS-PAGE.FORM_POSITION' | translate}}</mat-label>
                        <mat-select formControlName="formPosition">
                            <mat-option value="left">{{'SITE-DETAILS-PAGE.LEFT' | translate}}</mat-option>
                            <mat-option value="right">{{'SITE-DETAILS-PAGE.RIGHT' | translate}}</mat-option>
                            <mat-option value="center">{{'SITE-DETAILS-PAGE.CENTER' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center center">
                    <mat-form-field>
                        <input matInput formControlName="logoLink"
                            placeholder="{{'SITE-DETAILS-PAGE.LOGO_LINK' | translate}}">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{'SITE-DETAILS-PAGE.LOGO_POSITION' | translate}}</mat-label>
                        <mat-select formControlName="logoPosition">
                            <mat-option value="left">{{'SITE-DETAILS-PAGE.LEFT' | translate}}</mat-option>
                            <mat-option value="right">{{'SITE-DETAILS-PAGE.RIGHT' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <h2>{{'SITE-DETAILS-PAGE.HEADER_ITEMS' | translate}}</h2>
                <div fxLayout="column">
                    <ng-container formArrayName="headerMenuItems">
                        <ng-container *ngFor="let field of headerMenuItems.controls; let i = index" [formGroupName]="i">
                            <div fxLayout="row" fxLayoutGap="30px">
                                <mat-form-field>
                                    <input matInput formControlName="title"
                                        placeholder="{{'SITE-DETAILS-PAGE.TITLE' | translate}}">
                                </mat-form-field>
                                <mat-form-field>
                                    <input matInput formControlName="link"
                                        placeholder="{{'SITE-DETAILS-PAGE.LINK' | translate}}">
                                </mat-form-field>
                                <button mat-mini-fab color="warn"
                                    (click)="removeMenuItem(i)"><mat-icon>delete</mat-icon></button>
                            </div>
                        </ng-container>
                    </ng-container>
                    <mat-slide-toggle formControlName="spaceLogoAndItems">{{'SITE-DETAILS-PAGE.SPACE_LOGO_ITEMS' |
                        translate}}</mat-slide-toggle>
                </div>
                <h2>{{'SITE-DETAILS-PAGE.FOOTER' | translate}}</h2>
                <div fxLayout="row">
                    <mat-form-field>
                        <mat-label>{{'SITE-DETAILS-PAGE.FOOTER_LOGO_POSITION' | translate}}</mat-label>
                        <mat-select formControlName="footerLogoPosition">
                            <mat-option value="left">{{'SITE-DETAILS-PAGE.LEFT' | translate}}</mat-option>
                            <mat-option value="right">{{'SITE-DETAILS-PAGE.RIGHT' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center">
                    <button mat-mini-fab color="primary" (click)="addMenuItem()"><mat-icon>add</mat-icon></button>
                </div>
                <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center center">
                    <mat-form-field>
                        <input matInput formControlName="name" placeholder="{{'SITE-DETAILS-PAGE.NAME' | translate}}">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{'SITE-DETAILS-PAGE.DIRECTION' | translate}}</mat-label>
                        <mat-select formControlName="direction">
                            <mat-option value="ltr">{{'SITE-DETAILS-PAGE.LTR' | translate}}</mat-option>
                            <mat-option value="rtl">{{'SITE-DETAILS-PAGE.RTL' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                    <mat-slide-toggle formControlName="active">{{'SITE-DETAILS-PAGE.ACTIVE' |
                        translate}}</mat-slide-toggle>
                    <mat-slide-toggle formControlName="savePasswords">{{'SITE-DETAILS-PAGE.SAVE_PASSWORDS' |
                        translate}}</mat-slide-toggle>
                </div>
                <div class="color-container" fxLayout="row" fxLayoutGap="30px">
                    <div fxLayout="column">
                        <h2>{{'SITE-DETAILS-PAGE.BGCOLOR' | translate}}</h2>
                        <input [(colorPicker)]="backgroundColor" [style.background]="backgroundColor" />
                    </div>
                    <div fxLayout="column">
                        <h2>{{'SITE-DETAILS-PAGE.TEXT-COLOR' | translate}}</h2>
                        <input [(colorPicker)]="fontColor" [style.background]="fontColor" />
                    </div>
                    <div fxLayout="column">
                        <h2>{{'SITE-DETAILS-PAGE.CONTROL-COLOR' | translate}}</h2>
                        <input [(colorPicker)]="themeColor" [style.background]="themeColor" />
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <app-editor [formGroup]="siteForm" inputName="title" htmlInputName="titleHtml"></app-editor>
                    <mat-form-field>
                        <input matInput formControlName="formTitle"
                            placeholder="{{'SITE-DETAILS-PAGE.FORM-TITLE' | translate}}">
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <mat-form-field>
                        <input matInput formControlName="userNameTitle"
                            placeholder="{{'SITE-DETAILS-PAGE.USERNAME' | translate}}">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput formControlName="passwordTitle"
                            placeholder="{{'SITE-DETAILS-PAGE.PASSWORD' | translate}}">
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <mat-form-field>
                        <input matInput formControlName="userNamePlaceholder"
                            placeholder="{{'SITE-DETAILS-PAGE.PLACEHOLDER-USERNAME' | translate}}">
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput formControlName="passwordPlaceholder"
                            placeholder="{{'SITE-DETAILS-PAGE.PLACEHOLDER-PASSWORD' | translate}}">
                    </mat-form-field>
                </div>
                <div fxLayout="column" formArrayName="additionalFields">
                    <ng-container *ngFor="let field of additionalFields.controls; let i = index" [formGroupName]="i">
                        <div fxLayout="row" fxLayoutGap="30px">
                            <mat-form-field>
                                <input matInput formControlName="title"
                                    placeholder="{{'SITE-DETAILS-PAGE.TITLE' | translate}}">
                            </mat-form-field>
                            <mat-form-field>
                                <input matInput formControlName="placeholder"
                                    placeholder="{{'SITE-DETAILS-PAGE.PLACEHOLDER' | translate}}">
                            </mat-form-field>
                            <!--<mat-form-field>
                                <mat-select formControlName="type">
                                    <mat-option value="text">Text</mat-option>
                                    <mat-option value="password">Password</mat-option>
                                    <mat-option value="number">Number</mat-option>
                                    <mat-option value="email">Email</mat-option>
                                    <mat-option value="tel">Telephone</mat-option>
                                    <mat-option value="date">Date</mat-option>
                                </mat-select>
                            </mat-form-field>-->

                            <button mat-mini-fab color="warn"
                                (click)="removeAdditionalField(i)"><mat-icon>delete</mat-icon></button>
                        </div>
                    </ng-container>
                </div>
                <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center">
                    <button mat-mini-fab color="primary"
                        (click)="addAdditionalField()"><mat-icon>add</mat-icon></button>
                </div>
                <mat-form-field>
                    <input matInput formControlName="submitButtonLabel"
                        placeholder="{{'SITE-DETAILS-PAGE.BTN-SUBMIT-TEXT' | translate}}">
                </mat-form-field>
                <mat-slide-toggle formControlName="selectionField">{{'SITE-DETAILS-PAGE.CHOICE-FIELD' |
                    translate}}</mat-slide-toggle>
                <ng-container *ngIf="siteForm.value.selectionField">
                    <h2>{{'SITE-DETAILS-PAGE.CHOICE-FIELD' | translate}}</h2>
                    <mat-card>
                        <mat-form-field>
                            <mat-label>{{'SITE-DETAILS-PAGE.FIELD-TYPE' | translate}}</mat-label>
                            <mat-select formControlName="selectionFieldType">
                                <mat-option *ngFor="let fieldType of selectionFieldTypes" [value]="fieldType.value">{{
                                    fieldType.title }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="selectionFieldTitle"
                                placeholder="{{'SITE-DETAILS-PAGE.CHOICE-FIELD-TITLE' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="selectionFieldPlaceholder"
                                placeholder="{{'SITE-DETAILS-PAGE.CHOICE-FIELD-HINT' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="selectionFieldErrorMessage"
                                placeholder="{{'SITE-DETAILS-PAGE.ERROR-MESSAGE' | translate}}">
                        </mat-form-field>
                        <div fxLayout="column" fxLayoutAlign="start start" formArrayName="selectionFieldOptions">
                            <ng-container *ngFor="let fieldOption of fieldOptions?.controls; let i = index">
                                <div fxLayout="row">
                                    <mat-form-field>
                                        <input matInput [formControlName]="i" [placeholder]="'אפשרות ' + (i + 1)">
                                    </mat-form-field>
                                    <button mat-raised-button (click)="removeOption(i)">{{'SITE-DETAILS-PAGE.DELETE' |
                                        translate}}</button>
                                </div>
                            </ng-container>
                            <button mat-raised-button (click)="addOption()">{{'SITE-DETAILS-PAGE.ADD' |
                                translate}}</button>
                        </div>
                    </mat-card>
                </ng-container>
                <!-- <mat-form-field>
                    <input matInput formControlName="dateTitle" placeholder="כותרת תאריכים">
                </mat-form-field>
                <div formArrayName="dates">
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="30px">
                        <mat-form-field *ngFor="let date of datesFormArray; index as i">
                            <mat-label>תאריך {{ i + 1 }}</mat-label>
                            <input matInput [matDatepicker]="picker" [formControlName]="i">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div> -->
                <mat-form-field>
                    <input matInput formControlName="siteTitle"
                        placeholder="{{'SITE-DETAILS-PAGE.WEB-TITLE' | translate}}">
                </mat-form-field>
                <mat-form-field>
                    <input matInput formControlName="realDomain"
                        placeholder="{{'SITE-DETAILS-PAGE.REAL-URL' | translate}}">
                </mat-form-field>
                <mat-form-field>
                    <input matInput formControlName="phishingDomain"
                        placeholder="{{'SITE-DETAILS-PAGE.PHISHING-URL' | translate}}">
                </mat-form-field>
                <mat-form-field>
                    <input matInput formControlName="rightsMessage"
                        placeholder="{{'SITE-DETAILS-PAGE.NOTICE-RESERVED-RIGHTS' | translate}}">
                </mat-form-field>



                <h3>{{'SITE-DETAILS-PAGE.SEND-CONFIRM-MESSAGE' | translate}}</h3>
                <app-editor [formGroup]="siteForm" inputName="confirmationMessage"
                    htmlInputName="htmlCode"></app-editor>

                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="30px">
                    <div>
                        <h2>{{'SITE-DETAILS-PAGE.LOGO' | translate}}</h2>
                        <vzn-media #vznMedia formControlName="logo" uploadFolder="phishing-storage"
                            [uploadUrlService]="uploadUrlService" [autoUpload]="true">
                        </vzn-media>
                    </div>
                    <div>
                        <h2>{{'SITE-DETAILS-PAGE.BACKGROUND' | translate}}</h2>
                        <vzn-media #vznMedia formControlName="bgImage" [maxImageSize]="4096"
                            uploadFolder="phishing-storage" [uploadUrlService]="uploadUrlService" [autoUpload]="true">
                        </vzn-media>
                    </div>
                    <div>
                        <h2>{{'SITE-DETAILS-PAGE.CONTENT' | translate}}</h2>
                        <vzn-media #vznMedia formControlName="contentImage" uploadFolder="phishing-storage"
                            [uploadUrlService]="uploadUrlService" [autoUpload]="true">
                        </vzn-media>
                    </div>
                    <div>
                        <h2>{{'SITE-DETAILS-PAGE.FAVICON' | translate}}</h2>
                        <vzn-media #vznMedia formControlName="favicon" uploadFolder="phishing-storage"
                            [uploadUrlService]="uploadUrlService" [autoUpload]="true">
                        </vzn-media>
                    </div>
                </div>


                <div class="card-footer" fxLayoutAlign="center center" fxLayoutGap="15px">
                    <button mat-raised-button color="primary" (click)="onSubmit()">{{'SITE-DETAILS-PAGE.SAVE' |
                        translate}}</button>
                    <button mat-raised-button color="warn" (click)="deleteSite($event)">{{'SITE-DETAILS-PAGE.DEL' |
                        translate}}</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>